import { defaultDateFormat as configuredDefaultDateFormat } from "src/../src-dynamic/destination.config";

export type TDefaultDateFormat = "DD/MM/YYYY" | "MM/DD/YYYY" | "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL";

export const DEFAULT_DATE_FORMAT: TDefaultDateFormat = "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL";

export function normalizeDefaultDateFormat(format?: string | { format?: string }): TDefaultDateFormat {
  const resolvedFormat = typeof format === "string" ? format : format?.format;
  if (resolvedFormat === "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL") return "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL";
  if (resolvedFormat === "MM/DD/YYYY") return "MM/DD/YYYY";
  if (resolvedFormat === "DD/MM/YYYY") return "DD/MM/YYYY";
  return DEFAULT_DATE_FORMAT;
}

export function getDefaultDateFormat(): TDefaultDateFormat {
  return normalizeDefaultDateFormat(configuredDefaultDateFormat);
}

export function getDefaultDateFormatPattern(): string {
  if (getDefaultDateFormat() === "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL") return "";
  return getDefaultDateFormat() === "MM/DD/YYYY" ? "MM/dd/yyyy" : "dd/MM/yyyy";
}

export function isIntlDefaultDateFormat(format: TDefaultDateFormat = getDefaultDateFormat()): boolean {
  return format === "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL";
}
